/*
 *
 * Hedera Stablecoin SDK
 *
 * Copyright (C) 2023 Hedera Hashgraph, LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
import { transports } from 'winston';
import DailyRotateFile from 'winston-daily-rotate-file';
import LogService from '../../app/service/LogService.js';
import { ValidationError } from './request/error/ValidationError.js';
const DefaultLoggerFormat = LogService.defaultFormat;
// Log transports
export { transports as LoggerTransports };
export { DailyRotateFile };
export { DefaultLoggerFormat };
class SDK {
    static get log() {
        return SDK._log;
    }
    static set log(value) {
        SDK._log = value;
        new LogService(value);
    }
    static get appMetadata() {
        return SDK._appMetadata;
    }
    static set appMetadata(value) {
        SDK._appMetadata = value;
    }
}
export const handleValidation = (name, req) => {
    const validation = req.validate();
    if (validation.length > 0)
        throw new ValidationError(name, validation);
};
export { SDK };
